/*@ngInject*/
const TimingModel = function (browserUtil) {

    let timings = {};

    function getTime(){
        let perf = window.performance;

        if (browserUtil.isIE11() || browserUtil.isFirefox()) {
            return perf.now();
        } else {
            return Date.now();
        }
    }

    this.addMilestone = function (timingName, milestoneName) {

        let timingGroup = timings[timingName];

        if(!timingGroup) {
            timings[timingName] = {};
            timingGroup = timings[timingName];
        }

        timingGroup[milestoneName] = getTime();
    };

    this.getDuration = function (timingName, milestoneStart, milestoneEnd) {
        let timingGroup = timings[timingName],
            milestoneStartTime = timingGroup[milestoneStart],
            milestoneEndTime = timingGroup[milestoneEnd],
            duration = parseFloat(milestoneEndTime - milestoneStartTime),
            readableDuration = (duration > 1000 ? (duration / 1000).toFixed(1) + 's' : duration + 'ms');

        return readableDuration;
    };
};

angular.module('umCore').service('timingModel', TimingModel);
